import { PropsWithChildren } from 'react';

const H5 = (props: PropsWithChildren<any>) => <h5 className={'ds-h5'} {...props}>{props.children}</h5>;

export default H5;